import moment from "moment";

angular.module("app")
.directive("diapleGridFilterButton", ['uiGridConstants', function (uiGridConstants) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var gridOptions = scope[attrs.uiGrid];
            gridOptions.gridMenuCustomItems = [
                {
                    ref: 'btnShowHideFilter',
                    title: gridOptions.enableFiltering ? "Ocultar filtros" : "Mostrar filtros",
                    icon: "fa fa-filter",
                    action: function ($event) {
                        gridOptions.enableFiltering = !gridOptions.enableFiltering;
                        gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);

                        angular.forEach(gridOptions.gridMenuCustomItems, function (menuItem) {
                            if (menuItem.ref == "btnShowHideFilter") {
                                menuItem.title = gridOptions.enableFiltering ? "Ocultar filtros" : "Mostrar filtros";
                            }
                        });
                    },
                    order: 0
                }
            ];
        }
    };
}])


.directive("diapleGridExternalDataLoad", ['uiGridConstants', 'LoginService', '$timeout', function (uiGridConstants, LoginService, $timeout) {
    return {
        restrict: 'A',
        link: function (scope: any, element, attrs) {
            var gridOptions = scope[attrs.uiGrid];

            gridOptions.useExternalSorting = true;
            gridOptions.useExternalFiltering = true;
            gridOptions.useExternalPagination = true;

            //ajustamos altura grid a page size
            gridOptions.resizeHeight = function () {                

                if (gridOptions.enablePaginationControls) {
                    var _h = 130 + gridOptions.paginationPageSize * gridOptions.rowHeight;
                    element[0].style.height = _h + "px";
                } else {
                    gridOptions.gridApi.registerEvent('core', 'canvasHeightChanged');
                }
              
            };
            gridOptions.customResizeHeight = function (size) {
                
                if (size < 120) size = 120;                
                if (gridOptions.enableFiltering) {
                    //Tiene filtros.
                    var _h = 130 + size;
                } else {
                    if (gridOptions.enablePaginationControls) {
                        var _h = 90 + size;
                    } else {                        
                        var _h = 20 + size;
                    }                    
                }
                if (gridOptions.showColumnFooter)
                    _h += 50;
                element[0].style.height = _h + "px";
            };


            //formateado de pdf
            gridOptions.pdfFilterDescription = "";
            gridOptions.exporterPdfCustomFormatter = function (docDefinition) {
                docDefinition.pageMargins = [40, 60, 40, 40];
                var icon = LoginService.get("companyLogo");
                var columnsHeader: any = [{
                    text: angular.isFunction(gridOptions.pdfTitle) ? gridOptions.pdfTitle() : angular.isDefined(gridOptions.pdfTitle)?gridOptions.pdfTitle:  "Sin titulo",
                    fontSize: 16,
                    margin: [40, 30, 0, 0]
                }
                ]; 
                if (icon != null && icon != "undefined" && icon != "null") {
                    columnsHeader.push({
                        image: icon,
                        fit: [300, 40],
                        margin: [0, 20, 20, 0],
                        alignment: 'right'
                    });
                }
                docDefinition.header = {
                    columns: columnsHeader
                };
                docDefinition.footer = function (currentPage, pageCount) {
                    // you can apply any logic and return any valid pdfmake element
                    return {
                        columns: [
                            { text: moment().format("DD/MM/YYYY HH:mm:ss").toString(), alignment: 'left', margin: [40, 0, 0, 0] },
                            { text: currentPage.toString() + ' de ' + pageCount, alignment: 'right', margin: [0, 0, 40, 0] },
                        ]
                    };
                };
                //calculamos filtros internos
                gridOptions.pdfFilterDescription = "";
                angular.forEach(gridOptions.columnDefs, function (columnDef) {
                    if (columnDef.enableFiltering) {
                        //buscar valor d filtro
                        var valor = "";
                        angular.forEach(gridOptions.gridApi.grid.columns, function (column) {
                            if (column.name == columnDef.name) {
                                valor = column.filters[0].term;
                                if (angular.isDefined(column.filters[0].selectOptions)) {
                                    angular.forEach(column.filters[0].selectOptions, function (option) {
                                        if (option.value == valor) valor = option.label;
                                    });
                                }
                            }
                        });
                        if (typeof valor == "undefined" || valor == null) valor = "";
                        if (valor != "" && valor != null) gridOptions.pdfFilterDescription += (gridOptions.internalFilterDescription != "" ? "\n" : "") + columnDef.displayName + ": " + valor;
                    }
                });
                //calculamos filtros externos
                if (gridOptions.getFilterExternalDescription) {
                    var externalFilterDescription = gridOptions.getFilterExternalDescription();
                    if (gridOptions.pdfFilterDescription != "" && externalFilterDescription != "") {
                        gridOptions.pdfFilterDescription += "\n";
                    }
                    gridOptions.pdfFilterDescription += externalFilterDescription;
                }
                var filter = {
                    text: gridOptions.pdfFilterDescription,
                    fontSize: 11
                };
                docDefinition.content.splice(0, 0, filter);
                return docDefinition;
            };

            var sortBy = "";
            var sortDirection = "";

            function getOptions(allData) {
                var options: any = {};

                //paginacion                
                if (allData != true) {
                    options._page = gridOptions.paginationCurrentPage;
                    options._pageSize = gridOptions.paginationPageSize;
                }

                //ordenacion
                options._sortBy = sortBy;
                options._sortDirection = sortDirection;

                //filtrado
                angular.forEach(gridOptions.columnDefs, function (columnDef) {
                    if (columnDef.enableFiltering) {
                        //buscar valor d filtro
                        var valor = "";
                        angular.forEach(gridOptions.gridApi.grid.columns, function (column) {
                            if (column.name == columnDef.name) valor = column.filters[0].term;
                        });
                        if (typeof valor == "undefined" || valor == null) valor = "";
                        options[columnDef.name] = valor;
                    }
                });

                return options;
            };

            gridOptions.loadData = function (allData) {
                gridOptions.resizeHeight();                                
                gridOptions.getData(getOptions(allData)).then(function (results) {
                    
                    gridOptions.data = results;
                    gridOptions.totalItems = results.totalRows;
                    if (typeof (gridOptions.gridApi.selection) !== 'undefined' && gridOptions.gridApi.selection.getSelectAllState()) {
                        $timeout(function () { gridOptions.gridApi.selection.selectAllVisibleRows(); });
                    }
                }, function (response) {
                    scope.errorMessage = response.message;
                });
                
            };

            gridOptions.gridApi.core.on.sortChanged(scope, function (grid, sortColumns) {
                if (sortColumns.length == 0) {
                    sortBy = "";
                    sortDirection = "";
                } else {
                    sortBy = sortColumns[0].name;
                    switch (sortColumns[0].sort.direction) {
                        case uiGridConstants.ASC:
                            sortDirection = "asc";
                            break;
                        case uiGridConstants.DESC:
                            sortDirection = "desc";
                            break;
                        case undefined:
                            sortDirection = "";
                            break;
                    }
                }
                gridOptions.paginationCurrentPage = 1;
                gridOptions.loadData(false);
            });
            gridOptions.gridApi.core.on.filterChanged(scope, function () {
                if (angular.isDefined(gridOptions.filterTimeout)) {
                    $timeout.cancel(gridOptions.filterTimeout);
                }
                gridOptions.filterTimeout = $timeout(function () {
                    gridOptions.paginationCurrentPage = 1;
                    gridOptions.loadData(false);
                }, 300);
            });
            gridOptions.gridApi.pagination?.on.paginationChanged(scope, function (newPage, pageSize) {                
                gridOptions.pageValue = newPage;
                gridOptions.loadData(false);
            });
            

            gridOptions.gridApi.core.on.canvasHeightChanged(scope, function (lastSizeCanvas, actualSizeCanvas) {
                if (lastSizeCanvas != actualSizeCanvas) {
                    gridOptions.customResizeHeight(actualSizeCanvas);
                }
            });

            /**
            * hace que el exportar todos no tenga en cuenta el paginador
            */
            gridOptions.exporterAllDataFn = function () {
                return gridOptions.getData(getOptions(true)).then(function (results) {
                    gridOptions.data = results;
                    gridOptions.totalItems = results.totalRows;
                });
            };

            /**
            * Evento para lanzar cuando se borra algo.
            */
            gridOptions.gridApi.registerEvent('core', 'itemDeleted');

            gridOptions.gridApi.core.on.itemDeleted(scope, function () {
                gridOptions.loadData(false);
            });

            /**
            * Evento para lanzar cuando se edita o se añade algo.
            */
            gridOptions.gridApi.registerEvent('core', 'itemChanged');

            gridOptions.gridApi.core.on.itemChanged(scope, function () {
                gridOptions.loadData(false);
            });
            
            //carga inicial
            gridOptions.loadData(false);
        }
    };
}])

.directive("diapleGridAutoResize", ['uiGridConstants', function (uiGridConstants) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var gridOptions = scope[attrs.uiGrid];

            gridOptions.gridApi.registerEvent('core', 'canvasHeightChanged');

            gridOptions.customResizeHeight = function (size) {

                if (size < 120) size = 120;
                if (gridOptions.enableFiltering) {
                    //Tiene filtros.
                    var _h = 130 + size;
                } else {
                    if (gridOptions.enablePaginationControls) {
                        var _h = 90 + size;
                    } else {
                        var _h = 20 + size;
                    }
                }
                if (gridOptions.showColumnFooter)
                    _h += 50;
                element[0].style.height = _h + "px";
            };

            gridOptions.gridApi.core.on.canvasHeightChanged(scope, function (lastSizeCanvas, actualSizeCanvas) {
                if (lastSizeCanvas != actualSizeCanvas) {
                    gridOptions.customResizeHeight(actualSizeCanvas);
                }
            });

          
        }
    };
}])

;